import {SocialMediaUrl} from './socialMediaUrl';
import {GetSafeValue} from '../utils/get-safe-value';
import {StringFieldUtil} from '../utils/string-field-util';
import {Gps} from './gps';
import {StringUtils} from '../utils/string-utils';

export class Store {
  private _id: string;
  private _name: Map<string, string>;
  private _imageUrl: string;
  private _address: Map<string, string>;
  private _phoneNumber: string;
  private _openHour: Map<string, string>;
  private _storeMapUrl: SocialMediaUrl;
  private _documentPath: string;
  private _isEnable: boolean;
  private _gps: Gps;

  constructor() {
    this.storeMapUrl = new SocialMediaUrl();
    this.name = new Map();
    this.address = new Map();
    this.openHour = new Map();
    this.isEnable = null;
    this.imageUrl = "assets/images/users/default_profile.png";
    this._documentPath = "";
    this.gps = new Gps();
  }

  clone(data: Store){
    this.name = data.name;
    this.imageUrl = data.imageUrl;
    this.address = data.address;
    this.phoneNumber = data.phoneNumber;
    this.openHour = data.openHour;
    this.storeMapUrl.clone(data.storeMapUrl);
    this._documentPath = data._documentPath;
    this.gps = data.gps;
  }

  fromJson(data: Store){
    this._documentPath = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.documentPath], '');
    if([null, undefined].includes(data[StringFieldUtil.isEnable])){
      this.isEnable = null;
    }else {
      this.isEnable = data[StringFieldUtil.isEnable];
    }
    this.name = GetSafeValue.getSafeValueAsMap(data[StringFieldUtil.nameStore], {'en': "", 'kh': ""});
    this.imageUrl = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.imageUrl], null);
    this.address = GetSafeValue.getSafeValueAsMap(data[StringFieldUtil.address], {'en': "", 'kh': ""});
    this.phoneNumber = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.phoneNumber] != null
      ? data[StringFieldUtil.phoneNumber].substr(4) : data[StringFieldUtil.phoneNumber] , null);
    this.openHour = GetSafeValue.getSafeValueAsMap(data[StringFieldUtil.openHours], {'en': "", 'kh': ""});
    if(data[StringFieldUtil.storeMapUrl]) {
      this.storeMapUrl.fromJson(data[StringFieldUtil.storeMapUrl]);
    }
    if (data[StringFieldUtil.gps]) {
      this.gps.fromJson(data[StringFieldUtil.gps]);
    }
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get name(): Map<string, string> {
    return this._name;
  }

  set name(value: Map<string, string>) {
    this._name = value;
  }

  get imageUrl(): string {
    return this._imageUrl;
  }

  set imageUrl(value: string) {
    this._imageUrl = value;
  }

  get address(): Map<string, string> {
    return this._address;
  }

  set address(value: Map<string, string>) {
    this._address = value;
  }

  get phoneNumber(): string {
    return this._phoneNumber;
  }

  set phoneNumber(value: string) {
    this._phoneNumber = value;
  }

  get openHour(): Map<string, string> {
    return this._openHour;
  }

  set openHour(value: Map<string, string>) {
    this._openHour = value;
  }

  get storeMapUrl(): SocialMediaUrl {
    return this._storeMapUrl;
  }

  set storeMapUrl(value: SocialMediaUrl) {
    this._storeMapUrl = value;
  }


  get documentPath(): string {
    return this._documentPath;
  }

  set documentPath(value: string) {
    this._documentPath = value;
  }

  get isEnable(): boolean {
    return this._isEnable;
  }

  set isEnable(value: boolean) {
    this._isEnable = value;
  }


  get gps(): Gps {
    return this._gps;
  }

  set gps(value: Gps) {
    this._gps = value;
  }

  toMap() {
    console.log("gps", this.gps);
    return {
      "name" :{
        'en': this.name['en'],
        'kh': this.name['kh']
      },
      "address" :{
        'en': this.address['en'],
        'kh': this.address['kh']
      },
      "phoneNumber" : "+855" + this.phoneNumber,
      "openHours" : {
        'en': this.openHour['en'],
        'kh': this.openHour['kh']
      },
      "storeMapUrl": this.storeMapUrl.toMap(),
      "imageUrl": this.imageUrl,
      'documentPath': this._documentPath,
      "isEnable" : this.isEnable,
      "gps": this.gps.toMap()
    };
  }
}
